import React from 'react'
import { useIntl } from 'react-intl'

import { FormSubGroup, Label } from '../../layout'
import { SelectContainer, useTowingJobFilterContext } from '../context'

import { FilterSelect } from '../components/FilterSelect'
import { UserRole } from '../../../common/types'
import { jobFilterMessages } from '../../JobViewFilters/messages'
import { towingJobFilterMessages } from '../messages'
import { formatMessageSafe } from '../../../util/translateInputOptions'

type TowingVisibilityFilter = 'open' | 'own' | 'others'

interface Option {
  label: string
  value: TowingVisibilityFilter
}
interface VisibilityFilterProps {
  options?: Option[]
}

export const VisibilityFilter = ({ options }: VisibilityFilterProps) => {
  const { values, setValues, currentUser } = useTowingJobFilterContext()
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)

  const visibilityOptions: { label: string; value: TowingVisibilityFilter }[] = [
    { label: formatMessage(jobFilterMessages.visibility_open), value: 'open' },
    { label: formatMessage(jobFilterMessages.visibility_own), value: 'own' },
    { label: formatMessage(jobFilterMessages.visibility_others), value: 'others' },
  ]

  const limitedVisibilityOptions: { label: string; value: TowingVisibilityFilter }[] = [
    { label: formatMessage(jobFilterMessages.visibility_open), value: 'open' },
    { label: formatMessage(jobFilterMessages.visibility_own), value: 'own' },
  ]

  const showAllOptions = currentUser.role === UserRole.main_user || currentUser.role === UserRole.duty_officer
  const optionsValues = options ? options : showAllOptions ? visibilityOptions : limitedVisibilityOptions

  const handleVisibilityChange = (selectedOptions: any) => {
    const selectedValues = selectedOptions ? selectedOptions.map((opt: any) => opt.value) : []

    setValues({
      ...values,
      filters: {
        ...values.filters,
        visibility: selectedValues,
      },
    })
  }

  return (
    <FormSubGroup>
      <Label>{formatMessage(jobFilterMessages.visibility_heading)}</Label>
      <SelectContainer>
        <FilterSelect
          isMulti
          isSearchable={false}
          placeholder={formatMessage(towingJobFilterMessages.selectPlaceholder)}
          options={optionsValues.map(option => ({ value: option.value, label: option.label }))}
          value={optionsValues
            .filter(option => values.filters.visibility.includes(option.value))
            .map(option => ({ value: option.value, label: option.label }))}
          onChange={handleVisibilityChange}
        />
      </SelectContainer>
    </FormSubGroup>
  )
}
